var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.success)?_c('Success',{attrs:{"result":_vm.success,"organization":_vm.organization}}):_c('OrderForm',{attrs:{"tenant":_vm.$route.params.tenant,"organization":_vm.organization,"source":"INSPECTECH"},on:{"success":_vm.done}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }